import { Store, Common } from 'app/interfaces';

export default function updateTransaction(
  state: Store.State,
  transaction: Common.Transaction,
  transactionType: Common.TransactionType
) {
  state.transactions[transactionType] = transaction;
}
